import i18next from "i18next";

export enum TicketCheckInStatus {
  NOT_CHECKED_IN = "NOT_CHECKED_IN",
  CHECKED_IN = "CHECKED_IN",
}

export function fanCheckInStatusToString(
  status: TicketCheckInStatus | undefined,
) {
  if (status === TicketCheckInStatus.NOT_CHECKED_IN) {
    return i18next.t("common_userstatus_beforecheckin");
  } else if (status === TicketCheckInStatus.CHECKED_IN) {
    return i18next.t("common_userstatus_completecheckin");
  }
  return "";
}

export function fanCheckInStatusColor(status: TicketCheckInStatus | undefined) {
  if (status === TicketCheckInStatus.NOT_CHECKED_IN) {
    return "badge-outline";
  } else if (status === TicketCheckInStatus.CHECKED_IN) {
    return "badge-primary";
  }
  return "";
}
